import script from "./ProjectForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectForm.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectForm.vue?vue&type=style&index=0&id=aa7c7f02&lang=scss"

const __exports__ = script;

export default __exports__